export const hasProperty = (arg, fallback = "") => {
  try {
    return arg() || fallback;
  } catch (e) {
    return fallback;
  }
};
